
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Container,
    Form
} from "reactstrap";
import ReviewCompanyService from "../../../../services/reviewCompanyService";
import _ from "lodash"
import countries from "../../../../util/countriesGlobal";
import {companyType} from "../../../../util/companyType";
import UtilService from "../../../../services/utilService";
import ReviewCompanyForm from "./Form";

class ReviewCompanyEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            selectedCountry : {},
            selectedCompanyTypes : [],
            selectCountryKey : UtilService.uuidv4(),
            selectCompanyTypeKey :UtilService.uuidv4()
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCompanyTypeChange = this.handleCompanyTypeChange.bind(this);
        this.handleCountrySelectChange = this.handleCountrySelectChange.bind(this);
    }

    componentDidMount() {
        const {uniqueId} = this.props.match.params;
        ReviewCompanyService.fetch(uniqueId).then(response => {
            this.setState(response.data);
            this.setState({uniqueId: uniqueId});
            let selectedCountry = _.find(countries, { key: response.data.country });
            const filteredCompanyTypes = _.filter(companyType, (company) => _.includes(response.data.companyTypeList, company.key));
            this.setState({selectedCompanyTypes:filteredCompanyTypes,selectedCountry: selectedCountry, selectCountryKey : UtilService.uuidv4(), selectCompanyTypeKey: UtilService.uuidv4()});
        });
    }

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        ReviewCompanyService.update(this.state).then(response => {
            if (response.responseStatus === "SUCCESS") {
                this.props.history.push("/user/company/list");
            } else {
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
        });
    }

    handleCompanyTypeChange = (valueObj, event) => {
        if (_.isNull(valueObj)) {
            this.setState({companyTypeList: []});
        } else {
            this.setState({companyTypeList: valueObj});
            const keys = _.map(valueObj, "key")
            this.setState({companyTypeList: keys});
        }
    };

    handleCountrySelectChange(valueObj) {
        if (_.isNull(valueObj)) {
            this.setState({selectedCountry: {}, country: ""});
        } else {
            this.setState({selectedCountry: valueObj, country: valueObj.key});
        }
    }

    render() {
        return (
            <>
                <SimpleHeader
                    name="Edit"
                    parentName="Company"
                    heading="XareGrowth"
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Edit Company</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <ReviewCompanyForm
                                    selectCompanyTypeKey={this.state.selectCompanyTypeKey}
                                    selectCountryKey={this.state.selectCountryKey}
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}
                                    isEdit={true}
                                    selectedCountry = {this.state.selectedCountry}
                                    selectedCompanyTypes = {this.state.selectedCompanyTypes}
                                    companyType = {companyType}
                                    onCompanyTypeChange={this.handleCompanyTypeChange}
                                    handleCountrySelectChange={this.handleCountrySelectChange}
                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default" outline type="submit">
                                        Update
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default ReviewCompanyEdit;
